export const ConsoleHelper = (...data) => {
  if (process.env.MODE === 'production') return;
  console.log(Object.assign({}, data));
}